import { useOpts } from '../context';
import { checkHackyWorkspace } from '../utils/hacky-workspace-customizations';
var replaceSpaces = function (str) { return str.replace(' ', '\u00a0'); };
export default function useOrgName() {
    var _a = useOpts().linkTokenPayload, orgName = _a.orgName, workspaceName = _a.workspaceName;
    /*
     * Cash asked us to default their copy to Cash App no matter
     * the orgName passed in.
     * Since we want to be cool with Cash, we are doing the exception
     * directly on code.
     * https://pinwheel.atlassian.net/browse/CON-65
     */
    if (checkHackyWorkspace('Cash App', workspaceName)) {
        return replaceSpaces(workspaceName);
    }
    if (orgName)
        return replaceSpaces(orgName);
    return orgName;
}
